module.exports = __webpack_public_path__ + "img/header-12.319c576.jpeg";